// Social Media icons on the Homepage

export const HomepageConnect = () => {
  return (
    <div className="connect-container">
      <div className="linked-in-icon">
        <a href="https://www.linkedin.com/in/isaac-ola/" target="_blank">
          <img src="/images/linkedin-icon.png" alt="My LinkedIn Account"></img>
        </a>
      </div>
      <div className="github-icon">
        <a href="https://github.com/IsaacOlarewaju/" target="_blank">
          <img src="/images/github-icon.png" alt="My GitHub Account"></img>
        </a>
      </div>
      <div className="mail-icon">
        <a href="mailto:isaacola@me.com" target="_blank">
          <img src="/images/email-icon.png"></img>
        </a>
      </div>
    </div>
  );
};
